export { default } from './GridSectionContent.styled';
